<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-29 21:46:13
-->
<template>
  <div class="container">
    <div class="topContainer">
      <section class="leftContent">
        <section class="header">
          <div class="title">
            {{ this.auditStatus === 2 ? '审核' : '查看' }}
          </div>
          <div class="information service">
            <span style="white-space: nowrap">机构营业执照：</span>
            <div
              class="fileList"
              v-if="
                detail.businessLicenseUrl && detail.businessLicenseUrl.length
              "
            >
              <img
                class="imgBox"
                :key="index"
                v-for="(item, index) in detail.businessLicenseUrl"
                :src="item"
                alt=""
                @click="onShow(item)"
              />
            </div>
            <div v-else>暂无数据</div>
          </div>
          <div class="title">商品信息</div>
          <div class="information">
            商品名称：<span>{{ detail.goodsName || '-' }}</span>
          </div>
          <div class="information">
            商品类型：<span>{{ detail.goodsTypeName || '-' }}</span>
          </div>
          <div class="information">
            价格设置：<span
              >{{ detail.priceType === 2 ? detail.price + '元' : '面议' }}
            </span>
          </div>
          <div class="information">
            是否可用券：<span>{{ detail.useCoupon === 0 ? '否' : '是' }}</span>
          </div>
          <div class="information service">
            主图：
            <img
              class="imgBox"
              :src="detail.mainUrl"
              alt=""
              @click="onShow(detail.mainUrl)"
            />
          </div>
          <div class="information">
            收费模式：<span>{{ detail.chargeMode || '-' }}</span>
          </div>
          <div class="information">
            服务地区：<span>{{ detail.serveArea || '-' }}</span>
          </div>
          <div class="information">
            服务对象：<span>{{ detail.serveTargetNameStr || '-' }}</span>
          </div>
          <div class="information">
            服务方式：<span>{{ detail.serveWayNameStr || '-' }}</span>
          </div>
          <div class="information">
            商品简介：
            <div id="editor"></div>
          </div>
          <div class="information">
            <span class="left-title">附件下载：</span>
            <div class="fileBox" v-if="detail.attachmentList.length">
              <div
                class="fileItem"
                v-for="(item, index) in detail.attachmentList"
                :key="index"
                @click="downLoadFile(item)"
              >
                <i class="el-icon-tickets"></i> {{ item.fileName || '-' }}
              </div>
            </div>
            <span v-else>暂无</span>
          </div>
        </section>
        <section class="review" v-if="type === 'gov' && auditStatus == 2">
          <div>
            <el-form
              :model="message"
              ref="message"
              :rules="rules"
              label-width="80px"
              label-position="left"
            >
              <el-form-item label="审核：" prop="auditStatus">
                <el-radio-group v-model="message.auditStatus">
                  <el-radio :label="3">通过</el-radio>
                  <el-radio :label="4">驳回</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input
                  style="min-width: 100px"
                  type="textarea"
                  v-model="message.remark"
                  placeholder="请输入"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </section>
      </section>
      <auditRecord :goodsRecord="goodsRecordList"></auditRecord>
    </div>
    <div class="dialog-footer" v-if="type === 'gov' && auditStatus == 2">
      <el-button @click="handleClose">取 消</el-button>
      <Debounce :time="5000" :isDebounce="3">
        <button
          type="button"
          class="el-button el-button--primary el-button--medium"
          @click="submit('message')"
        >
          <span>确 定</span>
        </button>
      </Debounce>
    </div>
    <!-- <el-dialog :visible.sync="showImg" width="30%" class="showImg">
      <img width="100%" :src="exhibitImg" alt="" />
    </el-dialog> -->
    <el-image-viewer
      v-if="showImg"
      :on-close="
        () => {
          showImg = false
        }
      "
      :url-list="[exhibitImg]"
    />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import {
  productDetail,
  auditProduct
} from '@api/yardIntermediary/commodityManagement-gov'
import { entProductDetail } from '@api/yardIntermediary/commodityManagement-ent'
import auditRecord from './components/auditRecord'
import { wEditorDefaultConfig } from '@constant'

export default {
  components: { auditRecord, ElImageViewer },
  name: 'Live',
  data() {
    return {
      title: '',
      newEntInfo: {},
      dialogVisible: false,
      message: {
        auditStatus: '',
        remark: ''
      },
      rules: {
        auditStatus: [
          {
            required: true,
            message: '请选择审核是否通过',
            trigger: 'change'
          }
        ]
      },
      fileListImg: [],
      process: [],
      status: '',
      showImg: false,
      exhibitImg: '',
      goodsRecordList: [], // 审核记录
      detail: {
        attachmentList: []
      },
      fileList: [], // 附件下载
      id: '',
      auditStatus: '',
      organizationType: null,
      type: ''
    }
  },
  watch: {},
  computed: {},
  created() {
    this.id = this.$route.query.id
    this.auditStatus = this.$route.query.auditStatus
    this.organizationType = this.$route.query.organizationType
    this.type = this.$route.query.type || 'gov'
    if (this.id) {
      this.getProductDetail()
    }
  },
  mounted() {
    this.wangEditor()
  },
  methods: {
    /** 创建富文本编辑器 */
    wangEditor() {
      let E = window.wangEditor
      this.editor = new E('#editor')
      this.editor.customConfig = {
        ...this.editor.customConfig,
        ...wEditorDefaultConfig
      }
      // console.log(this.editor.customConfig)
      // 配置菜单栏，设置不需要的菜单
      // this.editor.config.excludeMenus = [
      //   'video'
      // ]
      // 富文本编辑器内容校验
      let that = this
      this.editor.customConfig.onblur = function(html) {
        // 失去焦点时触发校验
        if (that.editor.txt.html() == '<p><br></p>') {
          that.$refs.ruleForm.validateField('desc')
        } else {
          that.$refs.ruleForm.clearValidate('desc')
        }
      }
      this.editor.create()
    },
    getProductDetail() {
      let API
      const params = {
        id: this.id
      }

      if (this.type === 'ent') {
        API = entProductDetail({ ...params })
      } else {
        API = productDetail({ ...params })
      }
      API.then(res => {
        if (res.data.code === '0000') {
          const data = res.data.data
          const {
            brief,
            goodsName,
            goodsTypeName,
            priceType,
            price,
            useCoupon,
            chargeMode,
            serveArea,
            serveTargetNameStr,
            serveWayNameStr,
            goodsRecordList,
            img,
            attachmentList,
            businessLicenseUrl
          } = data
          this.goodsRecordList = goodsRecordList
          this.detail = {
            goodsName,
            goodsTypeName,
            priceType,
            price,
            useCoupon,
            chargeMode,
            serveArea,
            serveTargetNameStr,
            serveWayNameStr,
            mainUrl: img ? img.ossUrl : '',
            attachmentList,
            businessLicenseUrl
          }
          this.detail.businessLicenseUrl = this.detail.businessLicenseUrl.split(
            ','
          )
          this.editor.txt.html(brief)
        }
      })
    },
    /** 打开弹性 */
    onShow(item) {
      // console.log(item)

      this.exhibitImg = item
      this.showImg = true
    },
    /** 关闭联系企业清空弹窗 */
    handleClose() {
      this.$router.push({ name: 'productList' })
    },
    submit(formName) {
      
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = { ...this.message, id: this.id }
          auditProduct(data).then(res => {
            if (res.data.code == '0000') {
              this.$message.success(res.data.msg)
              this.$router.push({ name: 'productList' })
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    downLoadFile(d) {
      let url = d.ossUrl
      // pdf 预览，其他都下载
      const urlSuffixType = url.split('.')
      const urlType = urlSuffixType[urlSuffixType.length - 1]
      const openType = ['pdf'].includes(urlType.toLowerCase())
        ? '_blank'
        : '_self'
      window.open(url, openType)
    }
  }
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
.showImg {
  /deep/ .el-dialog__header {
    border-bottom: none !important;
  }
}
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .el-dialog__body {
    // height: 400px;
    overflow: auto;
    padding: 30px 60px 20px;
    font-size: 16px;
    .el-textarea__inner {
      height: 100px;
    }
  }
  .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }
  .el-upload-list__item {
    width: 120px;
    height: 120px;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.container {
  width: 100%;
  .topContainer {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    overflow: auto;
    & > .leftContent {
      width: 100%;
      height: calc(100% - 10px);
      background: white;
      overflow-y: scroll;
      &::-webkit-scrollbar-thumb {
        display: none;
      }
      > .header {
        background: white;
        padding-bottom: 20px;
        > .title {
          padding: 16px 21px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 600;
          border-bottom: 1px solid #eee;
        }
        .fileBox {
          width: 100% !important;
          display: flex;
          .fileItem {
            cursor: pointer;
            background: #f7f7f7;
            padding: 2px 5px;
            i {
              font-size: 15px;
              color: rgb(51, 153, 255);
              margin-right: 4px;
            }
          }
        }
        & > .service {
          > div {
            width: 100%;
            display: flex;
            > div {
              > div {
                margin-bottom: 10px;
                > span {
                  margin-right: 10px;
                }
              }
            }
          }
        }
        & > .information {
          padding: 0 24px 16px;
          margin-top: 16px;
          display: flex;
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          .imgBox {
            width: 148px;
            height: 148px;
            margin-right: 20px;
            border: 1px dashed #eee;
            cursor: pointer;
          }
          .left-title {
            white-space: nowrap;
          }
          .fileBox {
            color: rgba(0, 0, 0, 0.5);
            > div {
              margin-right: 20px;
            }
          }
          #editor {
            width: 800px;
          }
          span {
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }
      > .footer {
        margin-top: 16px;

        > .title {
          padding: 16px 21px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        }
        > .block {
          width: 60%;
          margin-top: 30px;
        }
      }
      > .review {
        // margin-top: 16px;
        padding: 24px 250px 60px;
        background: #fff;
        /deep/ .el-textarea__inner {
          min-height: 150px !important;
        }
      }
    }
  }
  .dialog-footer {
    width: calc(100% - 40px);
    display: flex;
    justify-content: center;
    position: absolute;
    text-align: center;
    bottom: 20px;
    background: #fff;
    padding: 10px 0;
  }
}
</style>
